export default __webpack_public_path__ + "static/media/page15.ddde06bb.webp";